if (!customElements.get('product-review-summary')) {
  class ProductReviewSummary extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.scoreElement = this.querySelector('[data-review-score]');
      this.countElement = this.querySelector('[data-review-count]');
      this.reviewLabel = this.dataset.reviewLabelSingular || 'Review';
      this.reviewsLabel = this.dataset.reviewLabel || 'Reviews';
      this.handleClick = this.handleClick.bind(this);
      this.syncFromWidget = this.syncFromWidget.bind(this);

      this.button?.addEventListener('click', this.handleClick);
      this.widgetObserver = new MutationObserver(this.syncFromWidget);
      this.widgetObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true,
      });
      this.syncFromWidget();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      this.widgetObserver?.disconnect();
    }

    syncFromWidget() {
      const ratingSource = document.querySelector('.product-content-hub .AirReviews-Blocks--RateCount');
      const countSource = document.querySelector(
        '.product-content-hub .AirReviews-Blocks--ReviewCount__Text'
      );

      if (!ratingSource || !countSource) return;

      const rating = Math.min(5, Math.max(0, Number.parseFloat(ratingSource.textContent) || 0));
      const countMatch = countSource.textContent.match(/[\d,]+/);
      const count = countMatch ? Number.parseInt(countMatch[0].replace(/,/g, ''), 10) : 0;
      const countLabel = count === 1 ? this.reviewLabel : this.reviewsLabel;
      const signature = `${rating.toFixed(1)}:${count}`;

      if (this.lastSignature === signature) return;
      this.lastSignature = signature;

      this.style.setProperty('--review-rating-percent', `${(rating / 5) * 100}%`);
      if (this.scoreElement) this.scoreElement.textContent = rating.toFixed(1);
      if (this.countElement) this.countElement.textContent = `${count} ${countLabel}`;
      if (this.button) {
        this.button.setAttribute(
          'aria-label',
          `${rating.toFixed(1)} out of 5, ${count} ${countLabel}. Jump to reviews`
        );
      }
    }

    handleClick() {
      const reviewsTab = document.querySelector(
        '.product-content-hub__tab[aria-controls^="ReviewsPanel-"]'
      );
      if (!reviewsTab) return;

      reviewsTab.click();
      window.requestAnimationFrame(() => {
        reviewsTab.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
        reviewsTab.focus({ preventScroll: true });
      });
    }
  }

  customElements.define('product-review-summary', ProductReviewSummary);
}
